import ArrSVG from '@public/icons/arr.svg';
import CloseSVG from '@public/icons/close-btn.svg';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useSetOpenedPopupsState } from '@/shared/atoms/opened-popups';
import Popup from '@/shared/components/shared/Popup';
import { ImageShape } from '@/shared/lib/types';
import Image from '../../shared/Image';
import Responsive from '../../shared/Responsive';
import Typografed from '../../shared/Typografed';
import { FOOD_AREA_POPUP_NAME } from '../FoodAreaPopup/FoodAreaPopup';
import { LIVE_PROGRAM_POPUP_NAME } from '../LiveProgramPopup/LiveProgramPopup';

export const SCHEMA_POPUP_NAME = 'schema-popup';

export type SchemaPopupProps = {
    overflow?: boolean;
    image: ImageShape;
    isBackBtn?: boolean;
    content?: {
        name: string;
        description?: string;
    };
    topSlot?: React.ReactNode;
};

function SchemaPopup({ image, content, overflow = false, topSlot, isBackBtn = false }: SchemaPopupProps) {
    const router = useRouter();
    const { closePopup } = useSetOpenedPopupsState();
    const isFoodAreaPage = router.pathname.includes('food-area');

    return (
        <Popup name={SCHEMA_POPUP_NAME} data-popup-preset="slide-right" className="schema-popup" overlay={true}>
            <div className="schema-popup-btns schema-popup-content__wrapper ">
                {(isFoodAreaPage || isBackBtn) && (
                    <div className="schema-popup-btns__back-wrapper ">
                        <button
                            className="menu-popup-close-btn schema-popup-btns__back"
                            aria-label="Назад"
                            onClick={() => {
                                closePopup(SCHEMA_POPUP_NAME);
                            }}
                        >
                            <ArrSVG />
                        </button>
                        <span className="text-s">Назад</span>
                    </div>
                )}
                <button
                    className="menu-popup-close-btn"
                    aria-label="Закрыть"
                    onClick={() => {
                        closePopup(FOOD_AREA_POPUP_NAME);
                        closePopup(LIVE_PROGRAM_POPUP_NAME);
                        closePopup(SCHEMA_POPUP_NAME);
                    }}
                >
                    <CloseSVG />
                </button>
            </div>
            <div className="schema-popup-content">
                {content && (
                    <div className="schema-popup-content__info schema-popup-content__wrapper ">
                        <p className="schema-popup-content__info-label text-xs">Место:</p>
                        <p className="schema-popup-content__info-value">
                            <Typografed>{content.name}</Typografed>
                        </p>
                    </div>
                )}
            </div>
            {image && (
                <Responsive className="schema-popup-content__image">
                    <Image
                        key={image.src}
                        className={classNames('schema-popup-content__img', {
                            'schema-popup-content__img--overflow': overflow,
                        })}
                        src={image.src}
                        alt={image.alt ?? ''}
                        width={image.width}
                        height={image.height}
                        sizes="(max-width: 1199px) 100vw, 50vw"
                        quality={100}
                        priority={true}
                        loading="eager"
                    />
                </Responsive>
            )}
        </Popup>
    );
}

export default SchemaPopup;
